const { newTracker, trackStructEvent } = require('@snowplow/browser-tracker');

const PRODUCTION = window.location.hostname !== 'localhost' && window.location.hostname !== 'cwl.local';
const SP_NAMESPACE = "sp-wl_search" + Math.random();

// Инициализируем трекер только в продакшене
if (PRODUCTION && !window.travelpayouts_metrics_off) {
  newTracker(SP_NAMESPACE, "avsplow.com", {
    appId: "tp_widgets",
    encodeBase64: false,
    postPath: '/a/j',
    contexts: {
      webPage: false,
      session: false,
      performanceTiming: false,
      gaCookies: false,
      clientHints: false,
    },
  });
}

const sendSnowplowEvent = (category, action, data) => {
  if (!PRODUCTION || window.travelpayouts_metrics_off) {
    return;
  }
  
  const customContext = {
    schema: 'event',
    data: data,
  };

  trackStructEvent(
    {
      category: category,
      action: action,
      property: "",
      value: undefined,
      context: [customContext],
    },
    [SP_NAMESPACE],
  );
};

module.exports = {
  sendEvent: sendSnowplowEvent
};
